import { getCustomersQuery } from '@setvi/shared/services';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useCallback } from 'react';

interface useCustomersApiProps {
  searchQuery: string;
}

export const useCustomersApi = ({ searchQuery }: useCustomersApiProps) => {
  const { data, isLoading, isFetching, hasNextPage, fetchNextPage } =
    useInfiniteQuery(
      getCustomersQuery({
        searchStr: searchQuery,
        limit: 20,
        offset: 0
      })
    );

  const fetchMoreCustomers = useCallback(() => {
    if (hasNextPage) fetchNextPage();
  }, [hasNextPage, fetchNextPage]);

  return {
    customers: data?.pages?.flatMap(page => page?.data),
    isLoading: isLoading || isFetching,
    fetchMoreCustomers
  };
};
